<template>
  <app-popup
    :active.sync="isActive" title="Квартиры несдающие показания" width="100%"
    class="employee-not-hand-over-values-popup"
  >
    <div class="employee-not-hand-over-values-popup__header">
      <div class="employee-not-hand-over-values-popup__main-action">
        <div
          class="employee-not-hand-over-values-popup__main-action-col employee-not-hand-over-values-popup__main-action-input"
        >
          <app-input
            vtype="uint" v-model="monthCount" label="Кол-во месяцев" :danger.sync="monthCountError"
            danger-text="Введите кол-во месяцев. Мин. 1"
          />
        </div>
        <div
          class="employee-not-hand-over-values-popup__main-action-col employee-not-hand-over-values-popup__main-action-button"
        >
          <app-button color="success" type="border" @click="updateData">Обновить</app-button>
        </div>
      </div>
      <div>
        <div class="link-icon employee-not-hand-over-values-popup__export" @click="exportTable">
          <app-icon name="DownloadFile" />
        </div>
      </div>
    </div>
    <div class="employee-not-hand-over-values-popup__content">
      <grid-infinite-scroll
        ref="table"
        :columns="tableColumns"
        :getData="updateValues"
        :maxConcurrentDatasourceRequests="4"
        :rowHeight="50"
        :pageSize="20"
        key="valueTable"
        :filterable="false"
        :sortable="false"
        noRowsText="Приборы не найдены"
      />
    </div>
  </app-popup>
</template>

<script>
import AccountNumberRenderer                   from "@/components/employee/accounts/AccountNumberRenderer";
import DeviceTypeRenderer                      from "@/components/calculated-program/metering/DeviceTypeRenderer";
import StatusRenderer                          from "@/components/calculated-program/metering/StatusRenderer";
import deviceStatuses                          from "@/dictionaries/deviceStatuses";
import { renderDeviceCell, renderDeviceValue } from "@/globalFunctions/renderDeviceValue";
import {
  renderDeviceOperationStartDate,
  renderDeviceOperationStartDateCell,
}                                              from "@/globalFunctions/renderDeviceOperationStartDate";

export default {
  name: "NotHandOverValuesPopup",
  data() {
    return {
      isActive:        false,
      monthCount:      1,
      monthCountError: false,
      deviceTypes:     [],
      statusesDict:    null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.getters['windowWidth'];
    },
    tableColumns() {
      return [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          editable:              false,
          suppressSizeToFit:     false,
          sortable:              true,
          filter:                true,
          pinned:                this.windowWidth < 500 ? "none" : "left",
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:        'Помещение',
          field:             'apartment',
          filter:            true,
          editable:          false,
          suppressSizeToFit: false,
          minWidth:          120,
          pinned:            this.windowWidth < 500 ? "none" : "left",
          valueGetter:       ( cell ) => {
            if (cell.node.rowPinned) {
              return '';
            }
            return cell.data.general !== true && cell.data.apartment ? cell.data.apartment.number : 'Общедомовой';
          },
        },
        {
          headerName:            'Тип',
          field:                 'type',
          filter:                'select',
          pinned:                this.windowWidth < 500 ? "none" : "left",
          filterParams:          {
            multiple: true,
            options:  this.deviceTypes.map(dt => ({
              value: dt.id,
              label: dt.name,
            })).sort(( a, b ) => a.value - b.value),
          },
          suppressSizeToFit:     false,
          editable:              false,
          cellRendererFramework: DeviceTypeRenderer,
          cellRendererParams:    ( { data } ) => Object.assign({
            canEdit: false,
          }, data),
          valueGetter:           ( { data } ) => {
            let type = data.type !== null ? this.getDeviceTypesById(data.type) : 'Не известный';
            let factoryNumber = data.factory_number !== null ? data.factory_number : 'Без номера';
            return `${type}(${factoryNumber})`;
          },
        },
        {
          headerName:            'Статус',
          field:                 'actual_state',
          filter:                false,
          editable:              false,
          minWidth:              120,
          suppressSizeToFit:     false,
          cellRendererFramework: StatusRenderer,
          cellRendererParams:    ( { data } ) => data,
          valueGetter:           ( { data } ) => {
            return this.statusesDict[data.actual_state].name;
          },
        },
        {
          headerName:  'Ввод в экспл.',
          field:       'operation_start_date',
          minWidth:    120,
          maxWidth:    120,
          editable:    false,
          filter:      false,
          valueGetter:  ( { data } ) => renderDeviceOperationStartDate(data.operation_start_date),
          cellRenderer: ( { data } ) => renderDeviceOperationStartDateCell(data.operation_start_date),
        },
        {
          headerName:   'След. поверка',
          field:        'next_checking_date',
          editable:     false,
          minWidth:     120,
          maxWidth:     120,
          filter:       false,
          cellRenderer: ( cell ) => {
            let style = "";
            let value = "";
            let title = "";

            let deviceDate = this.$moment(cell.value);
            let nowDate = this.$moment(Date.now());
            let data = "";

            if (cell.value !== null) {
              if (nowDate.isAfter(deviceDate)) {
                style = "color: rgba(var(--app-danger), 1)";
                title = "У прибора вышел срок поверки";
              } else if (deviceDate.diff(nowDate, 'months') < 3) {
                style = "color: rgb(246, 193, 81)";
                title = "До срока поверки осталось меньше 3 месяцев";
                data = "data-high-contrast-color=\"warning\"";
              }
              value = this.$options.filters.moment(cell.value);
            } else {
              value = "-";
            }
            return `<span style="${style}" title="${title}" ${data}>${value}</span>`;
          },
          valueGetter:  ( { data } ) => {
            return data.next_checking_date;
          },
        },
        {
          headerName:   'Собственник',
          field:        'apartment.b_owner',
          minWidth:     250,
          flex:         2,
          editable:     false,
          filter:       false,
          cellRenderer: ( { value } ) => {
            const text = value || '-';
            return `<span title="${text}">${text}</span>`;
          },
        },
        {
          headerName:  'Телефон',
          field:       'phone',
          minWidth:    100,
          flex:        2,
          editable:    false,
          filter:      false,
          valueGetter: ( { data } ) => {
            const { apartment } = data;
            if (!apartment) return '-';
            const { owners_u_a } = apartment;
            if (!owners_u_a) return '-';
            return owners_u_a.reduce(( phones, owner ) => {
              const { user: { telephone } } = owner;
              if (telephone) phones.push(telephone.toString());
              return phones;
            }, []).join(', ') || '-';
          },
        },
        // {
        //   headerName:        'Начальное',
        //   field:             'start_value',
        //   minWidth:          90,
        //   editable:          false,
        //   suppressSizeToFit: false,
        //   filter:            false,
        //   valueGetter:       ( { data } ) => {
        //     return data.start_value !== null ? Number(data.start_value) : '-';
        //   },
        // },
        {
          headerName:        'Последнее',
          field:             'last_value',
          minWidth:          90,
          editable:          false,
          suppressSizeToFit: false,
          filter:            false,
          cellRenderer:      ( cell ) => {
            const { values } = cell.data;
            if (!values) return '-';
            const value = values[values.length - 1];
            if (!value) return '-';
            return renderDeviceCell(cell.data, value);
          },
          valueGetter:       ( cell ) => {
            const { values } = cell.data;
            if (!values) return '-';
            const value = values[values.length - 1];
            if (!value) return '-';
            return renderDeviceValue(cell.data, value);
          },
        },
        {
          headerName:   'Комментарий',
          field:        'comment',
          minWidth:     150,
          flex:         2,
          editable:     false,
          filter:       false,
          valueGetter:  ( { data } ) => {
            return data.comment !== null ? data.comment : '-';
          },
          cellRenderer: ( { value } ) => {
            return value !== null ? `<span title="${value}">${value}</span>` : '';
          },
        },
      ];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    exportTable() {
      this.$vs.loading();
      this.$refs.table.exportRows('Квартиры несдающие показания');
    },
    open() {
      this.isActive = true;
    },
    updateData() {
      if (Number(this.monthCount) < 1) {
        this.monthCountError = true;
        return false;
      } else {
        this.$refs.table.resetData();
      }
    },
    updateValues( page, filters, orderBy ) {
      let params = {
        orderby:      orderBy,
        filters:      filters,
        page:         page,
        buildings_id: this.selectedHouseId,
        month:        this.monthCount,
      };
      return this.$http.get('device_with_no_values', { params }).then(( { data } ) => {
        this.$vs.loading.close();
        return {
          response: data,
          data:     data.data,
          total:    data.total,
        };
      });
    },
    getDeviceTypesById( id ) {
      let deviceType = this.deviceTypes.find(deviceType => Number(deviceType.id) === Number(id));
      return deviceType ? deviceType.name : 'Неизвестное устройство';
    },
    getDeviceTypes() {
      return new Promise(async resolve => {
        let { data } = await this.$http.get('devices_type');
        this.deviceTypes = data;
        resolve(data);
      });
    },
    loadStatuses() {
      deviceStatuses.getDict().then(dict => this.statusesDict = dict);
    },
  },
  mounted() {
    this.getDeviceTypes();
    this.loadStatuses();
  },
};
</script>

<style lang="scss">
.employee-not-hand-over-values-popup {

  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal__body {
    height: 100%;
  }

  .modal__content {
    display: flex;
    flex-direction: column;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    flex-shrink: 0;
  }

  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__main-action {
    display: flex;
    align-items: flex-end;
    margin: -8px;

    &-col {
      padding: 8px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}
</style>
